"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
require("./EditableInput.less");
var _excluded = ["active", "addonAfter", "className", "disabled", "editable", "InputComponent", "name", "onEdit", "placeholder", "processing", "saveButton"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var AddonAfter = function AddonAfter(_ref) {
  var active = _ref.active,
    disabled = _ref.disabled,
    editable = _ref.editable,
    editButton = _ref.editButton,
    _ref$onEdit = _ref.onEdit,
    onEdit = _ref$onEdit === void 0 ? _lodash.noop : _ref$onEdit,
    processing = _ref.processing,
    saveButton = _ref.saveButton;
  if (processing) {
    return /*#__PURE__*/_react.default.createElement(_spin.default, {
      indicator: /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: "loading",
        spin: true
      })
    });
  } else if (active) {
    return (0, _lodash.isUndefined)(saveButton) ? /*#__PURE__*/_react.default.createElement(_button.default, {
      disabled: disabled,
      htmlType: "submit",
      icon: "save",
      shape: "circle",
      type: "link"
    }) : saveButton;
  } else if (editable) {
    return (0, _lodash.isUndefined)(editButton) ? /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: onEdit,
      shape: "circle",
      type: "link"
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      className: "icon-pencil"
    })) : editButton;
  }
  return null;
};
var EditableInput = function EditableInput(_ref2, ref) {
  var active = _ref2.active,
    addonAfter = _ref2.addonAfter,
    className = _ref2.className,
    disabled = _ref2.disabled,
    _ref2$editable = _ref2.editable,
    editable = _ref2$editable === void 0 ? false : _ref2$editable,
    _ref2$InputComponent = _ref2.InputComponent,
    InputComponent = _ref2$InputComponent === void 0 ? _input.default : _ref2$InputComponent,
    name = _ref2.name,
    _ref2$onEdit = _ref2.onEdit,
    handleEdit = _ref2$onEdit === void 0 ? _lodash.noop : _ref2$onEdit,
    placeholder = _ref2.placeholder,
    processing = _ref2.processing,
    saveButton = _ref2.saveButton,
    extraProps = _objectWithoutProperties(_ref2, _excluded);
  var onEdit = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    event.stopPropagation();
    handleEdit();
  }, [handleEdit]);
  return /*#__PURE__*/_react.default.createElement(InputComponent, _extends({
    addonAfter: /*#__PURE__*/_react.default.createElement(AddonAfter, {
      active: active,
      editButton: addonAfter,
      disabled: disabled,
      editable: editable,
      onEdit: onEdit,
      processing: processing,
      saveButton: saveButton
    }),
    className: (0, _classnames.default)('editable-input', className),
    disabled: !active,
    name: name,
    placeholder: placeholder,
    ref: ref,
    size: "large"
  }, extraProps));
};
var _default = /*#__PURE__*/_react.default.forwardRef(EditableInput);
exports.default = _default;